/* eslint-disable */
import { CommonGet, CommonPost } from '../../../helpers/HttpClient';

export default {
    GetProductDetails,
    GetAllGroups,
    GetProductCategoties,
    GetProductTypes,
    GetFactoriesByGroupID,
    GetRouteByFactoryID,
    GetFarmerDetailsByFactoryIDRouteID,
    GetAllProductVarietyByProductID,
    GetProductsByFactoryIDProductcatogeryID,
    GetDemandSuplyFarmerwise,
    GetDemandSuplyCropwise
};

async function GetProductCategoties() {
    const response = await CommonGet('/api/ProductCategory/GetProductCategoryDetails', null);
    return response.data;
}

async function GetProductTypes() {
    const response = await CommonGet('/api/ProductType/GetAllProductTypes', null);
    return response.data;
}

async function GetProductDetails(productcatogeryID) {
    const response = await CommonGet('/api/Product/GetAllProducts', 'productcatogeryID=' + parseInt(productcatogeryID));
    return response.data;
}

async function GetAllGroups() {
    const response = await CommonGet('/api/Group/GetAllGroups', null);
    return response.data;
}

async function GetFactoriesByGroupID(groupID) {
    const response = await CommonGet('/api/Factory/GetFactoriesByGroupID', 'groupID=' + parseInt(groupID));
    return response.data;
}

async function GetRouteByFactoryID(factoryID) {
    const response = await CommonGet('/api/Group/GetRouteByFactoryID', 'factoryID=' + parseInt(factoryID));
    return response.data;
}

async function GetFarmerDetailsByFactoryIDRouteID(factoryID) {
    const response = await CommonGet('/api/Farmer/GetFarmerDetailsByFactoryIDRouteID', 'factoryID=' + parseInt(factoryID) + '&routeID=' + parseInt(0));
    return response.data;
}

async function GetAllProductVarietyByProductID(productID) {
    const response = await CommonGet('/api/Product/GetAllProductVarietyByProductID', 'productID=' + productID);
    return response.data;
}

async function GetProductsByFactoryIDProductcatogeryID(factoryID, productcatogeryID) {
    const response = await CommonGet('/api/Product/GetProductsByFactoryIDProductcatogeryID', 'factoryID=' + parseInt(factoryID) + '&productcatogeryID=' + parseInt(productcatogeryID));
    return response.data;
}

async function GetDemandSuplyCropwise(operationEntityID, cropID, fromDate, toDate) {
    const response = await CommonGet('/api/OrderDemandSupply/GetDemandSuplyCropwise', 'operationEntityID=' + parseInt(operationEntityID) + '&cropID=' + cropID + '&fromDate=' + fromDate + '&toDate=' + toDate);
    return response.data;
}

async function GetDemandSuplyFarmerwise(operationEntityID, farmerID, fromDate, toDate) {
    const response = await CommonGet('/api/OrderDemandSupply/GetDemandSuplyFarmerwise', 'operationEntityID=' + parseInt(operationEntityID) + '&farmerID=' + farmerID + '&fromDate=' + fromDate + '&toDate=' + toDate);
    return response.data;
}
